/* Florescer Busca V1 — vocabulário editorial 1.0 (27-09-2026).
   Alterar somente após revisão dos valores canônicos nos metafields públicos da Shopify.
   Nenhum resultado de produto é inferido destes caminhos: a lista vem exclusivamente da Predictive Search. */
(() => {
  const vocabulary = {
    sentimentos: [
      ['fs_jeito', 'Falar sobre sentimentos'], ['fs_objetivo', 'Emoções e conversas'], ['fs_habilidade', 'Consciência emocional']
    ],
    rotina: [['fs_jeito', 'Rotina e conquistas'], ['fs_objetivo', 'Rotina e autonomia']],
    coordenacao: [['fs_objetivo', 'Coordenação e precisão das mãos'], ['fs_habilidade', 'Coordenação motora fina']],
    atencao: [['fs_objetivo', 'Atenção e concentração'], ['fs_habilidade', 'Atenção e concentração']],
    massinha: [['fs_jeito', 'Mãos na massa']],
    encaixe: [['fs_jeito', 'Encaixar e organizar']]
  };
  // Valores de contexto somente se confirmados no catálogo; não há alias de contexto nesta V1.
  const canonicalContext = 'Espaço de atendimento';
  const labels = { fs_jeito: 'Jeitos de brincar', fs_objetivo: 'O que você quer apoiar?', fs_habilidade: 'Habilidades', fs_contexto: 'Contextos' };
  const slug = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const text = (tag, className, content) => { const node = document.createElement(tag); if (className) node.className = className; if (content != null) node.textContent = content; return node; };
  const safeProductUrl = (value) => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+/i.test(url.pathname) ? url.href : null; }
    catch { return null; }
  };
  const root = document.querySelector('[data-fs-search]');
  if (!root) return;
  const trigger = document.querySelector('[data-fs-search-open]');
  const panel = root.querySelector('.fs-search__panel');
  const input = root.querySelector('[data-fs-search-input]');
  const content = root.querySelector('[data-fs-search-content]');
  const endpoint = root.dataset.endpoint;
  const allUrl = root.dataset.allUrl || '/collections/all';
  const searchUrl = root.dataset.searchUrl || '/search';
  let timer, controller, sequence = 0, previousFocus, previousOverflow = '';
  const fallback = (query) => `${searchUrl}?${new URLSearchParams({ q: query })}`;
  const heading = (name) => text('p', 'fs-search__eyebrow', name);
  const footer = (query) => { const a = text('a', 'fs-search__footer', 'Ver todos os resultados →'); a.href = fallback(query); return a; };
  const paths = (query) => {
    const normalized = slug(query);
    if (!normalized) return [];
    const entries = Object.entries(vocabulary).filter(([key]) => key.startsWith(normalized) || normalized === key);
    const paths = entries.flatMap(([, axes]) => axes);
    if (normalized === slug(canonicalContext)) paths.push(['fs_contexto', canonicalContext]);
    return paths.filter(([key, label], index, array) => array.findIndex(([k, l]) => k === key && l === label) === index);
  };
  const renderAxes = (axes) => {
    if (!axes.length) return null;
    const aside = text('aside', 'fs-search__aside');
    for (const [key, title] of Object.entries(labels)) {
      const matches = axes.filter(([axis]) => axis === key);
      if (!matches.length) continue;
      aside.append(text('h3', 'fs-search__group-title', title));
      matches.forEach(([, label]) => {
        const a = text('a', 'fs-search__axis', label);
        const url = new URL(allUrl, location.origin);
        url.searchParams.set(key, slug(label));
        a.href = url.href;
        a.append(text('span', '', '→'));
        aside.append(a);
      });
    }
    return aside;
  };
  const render = (query, products, axes, status) => {
    content.replaceChildren();
    if (status === 'initial') {
      content.append(heading('Comece por uma ideia'), text('p', 'fs-search__intro', 'Explore brinquedos e caminhos para brincar.'));
      ['sentimentos', 'rotina', 'coordenação', 'atenção', 'massinha', 'encaixe'].forEach((term) => {
        const button = text('button', 'fs-search__term', term[0].toUpperCase() + term.slice(1));
        button.type = 'button';
        button.append(text('span', '', '→'));
        button.addEventListener('click', () => { input.value = term; input.focus(); update(); });
        content.append(button);
      });
      return;
    }
    if (status === 'typing') { content.append(text('p', 'fs-search__intro', 'Continue escrevendo para encontrar resultados.')); return; }
    if (status === 'loading') { content.append(text('p', 'fs-search__intro', 'Buscando na loja…')); return; }
    if (status === 'error') {
      content.append(text('p', 'fs-search__empty', 'Não foi possível buscar agora.'), text('p', 'fs-search__intro', 'Você ainda pode usar a busca da loja.'), footer(query)); return;
    }
    if (!products.length && !axes.length) {
      content.append(text('p', 'fs-search__empty', 'Nenhum resultado por aqui.'), text('p', 'fs-search__intro', 'Tente outra palavra ou veja a busca completa.'), footer(query)); return;
    }
    const grid = text('div', 'fs-search__grid');
    const main = text('div', 'fs-search__products');
    if (products.length) {
      main.append(heading('Produtos'));
      products.forEach((product) => {
        const url = safeProductUrl(product.url);
        if (!url) return;
        const a = text('a', 'fs-search__product'); a.href = url;
        const image = product.featured_image?.url || product.image;
        if (typeof image === 'string' && /^https:\/\//.test(image)) {
          const img = text('img'); img.src = image; img.alt = product.featured_image?.alt || product.title || ''; img.loading = 'lazy'; a.append(img);
        }
        const info = text('span', 'fs-search__product-info'); info.append(text('span', '', product.title || 'Produto'));
        const price = Number(product.price);
        if (Number.isFinite(price)) {
          try { info.append(text('span', 'fs-search__product-price', new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: root.dataset.currency || 'BRL' }).format(price))); } catch { /* preços nunca são inventados */ }
        }
        if (typeof product.available === 'boolean') info.append(text('span', 'fs-search__muted', product.available ? 'Disponível' : 'Esgotado'));
        a.append(info); main.append(a);
      });
    }
    const aside = renderAxes(axes);
    if (aside) grid.append(main, aside);
    else if (main.children.length) grid.append(main);
    content.append(grid, footer(query));
  };
  const cancel = () => { clearTimeout(timer); controller?.abort(); controller = null; sequence++; };
  const update = () => {
    cancel();
    const query = input.value.trim();
    if (!query) { render('', [], [], 'initial'); return; }
    if (query.length < 2) { render(query, [], [], 'typing'); return; }
    const current = sequence;
    render(query, [], [], 'loading');
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(endpoint || '/search/suggest.json', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'show');
      try {
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Busca indisponível');
        const payload = await response.json();
        if (current !== sequence || root.hidden) return;
        const products = payload?.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Resposta indisponível');
        render(query, products, paths(query), 'results');
      } catch (error) {
        if (current === sequence && !root.hidden && error?.name !== 'AbortError') render(query, [], [], 'error');
      }
    }, 250);
  };
  const open = () => {
    previousFocus = document.activeElement;
    document.querySelectorAll('.fl-header__desktop details,.fl-header__mobile details').forEach((item) => { item.open = false; });
    root.hidden = false;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    update();
    input.focus();
  };
  const close = () => { cancel(); root.hidden = true; document.body.style.overflow = previousOverflow; previousFocus?.focus?.(); };
  trigger?.addEventListener('click', open);
  root.querySelectorAll('[data-fs-search-close]').forEach((button) => button.addEventListener('click', close));
  input.addEventListener('input', update);
  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter((item) => item.getClientRects().length);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
  });
  // Enter in the input submits the native Shopify search form; suggestions are regular links/buttons.
  render('', [], [], 'initial');
})();